export const PLAYBACK_RATES = [
  { label: '0.5x', value: 0.5 },
  { label: '0.75x', value: 0.75 },
  { label: '1x (Normal)', value: 1 },
  { label: '1.25x', value: 1.25 },
  { label: '1.5x', value: 1.5 },
]

export const SKIP_AMOUNT = 10 // seconds

// The current time is updated at this interval while scrubbing
export const SCRUB_INTERVAL = 250

// A minimum scrubbing factor to apply (i.e. seconds to move per second)
// or a percentage of the total duration; if the percentage duration is
// less than the scrubbing factor the latter will apply ensuring scrubbing
// at the minimum rate.
export const SCRUB_SPEEDS = [
  { factor: 10 },
  { factor: 20 },
  { factor: 30, percent: 4 },
  { factor: 50, percent: 8 },
]
